var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoHistoriqueImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.615,
    height: 11.233,
    viewBox: "0 0 12.615 11.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3543",
    "data-name": "Groupe 3543",
    transform: "translate(-127.096 -11.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_55",
    "data-name": "Groupe 55",
    transform: "translate(136.048 19.358) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_789",
    "data-name": "Trac\\xE9 789",
    d: "M1622.219,709.857l2.645-2.645,2.645,2.645",
    transform: "translate(-1622.219 -707.212)",
    fill: "none",
    stroke: "#11264c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_9",
    "data-name": "Ligne 9",
    y2: 6.695,
    transform: "translate(2.642 0.03)",
    fill: "none",
    stroke: "#11264c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_969",
    "data-name": "Trac\\xE9 969",
    d: "M1622.334,734.371V735.9a1.013,1.013,0,0,1-1.013,1.013h-9.089a1.013,1.013,0,0,1-1.013-1.013v-1.529",
    transform: "translate(-1483.373 -714.546)",
    fill: "none",
    stroke: "#11264c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoHistoriqueImport);
export default __webpack_public_path__ + "static/media/picto-historique-import.2c8633cad3c7b888535d36e2afd4655d.svg";
export { ForwardRef as ReactComponent };